import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { IRockQueryParam, Rocks } from "models/rocks";
import { PaginatedResult } from "models/queryable";
import { ClientEngagement } from "models/client-engagement";
import Client from "models/client";
import Opportunity from "models/opportunity";
import Employee from "models/employee";
import ClientEngagementFields from "Components/organisms/forms/client-engagement-form/types";

export const getClientEngagements = async (query?: IRockQueryParam): Promise<PaginatedResult<ClientEngagement> | null> => {
    try {
        let queryString = '';
        if (query) {
            const params = new URLSearchParams();

            Object.entries(query).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') return;

                if (Array.isArray(value)) {
                    value.forEach(v => {
                        if (v) params.append(key, v);
                    });
                } else {
                    params.append(key, String(value));
                }
            });

            queryString = params.toString();
        }

        const url = `${process.env.REACT_APP_API_URL}/client-engagement${queryString ? `?${queryString}` : ''}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as PaginatedResult<ClientEngagement>

    } catch (err: any) {
        toast.error(err.message ?? "Error getting Client Engagements");
        return null;
    }
}

export const getClientEngagementSearchFields = async (): Promise<{
    clients: Client[],
    opportunities: Opportunity[],
    employees: Employee[]
} | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client-engagement/search-fields`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });


        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as {
            clients: Client[],
            opportunities: Opportunity[],
            employees: Employee[]
        }
    } catch (err: any) {
        toast.error(err.message ?? "Error getting rocks");
        return null
    }
}


export const submitCreateClientEngagementForm = async (vals: ClientEngagementFields, handleResetForm: () => any): Promise<ClientEngagement | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client-engagement`

        // Clean object
        const keys = Object.keys(vals);

        keys.forEach(k => {
            if (vals[k] === "")
                vals[k] = undefined;
        })


        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        })


        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }
        toast.success("Client Engagement Created.")
        const data = await res.json()
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error submitting Rocks form");
        return null;
    }
}


export const submitEditClientEngagementForm = async (ClientEngagementId: string, vals: ClientEngagementFields, handleResetForm: () => any): Promise<ClientEngagement | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client-engagement/${ClientEngagementId}`

        // Clean object
        const keys = Object.keys(vals);

        keys.forEach(k => {
            if (vals[k] === "")
                vals[k] = undefined;
        })
        const res = await fetch(url, {
            credentials: 'include',
            method: 'PUT',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        })

        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }



        toast.success("Client Engagement updated.")
        handleResetForm()
        const data = await res.json();
        return data.data
    } catch (err: any) {
        toast.error(err.message ?? "Error editing Rocks");
        return null;
    }
}


export const getClientEngagement = async (clientEngagementId: string) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client-engagement/${clientEngagementId}`

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        })


        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }

        const clientEngagement = await res.json();
        return clientEngagement.data
    } catch (err: any) {
        toast.error(err.message ?? "Error gettting Rock");
        return null;
    }
}


export const deleteClientEngagement = async (id: string): Promise<boolean> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/client-engagement/${id}`, {
            credentials: 'include',
            method: 'DELETE',
        });
        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }
        toast.success("Client Engagement deleted.");
        return true;
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting Client Engagement");
        return false;
    }
}